import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  useTheme,
  Button,
  IconButton,
  Tooltip,
} from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';

// 로컬 스토리지 키
const USER_LOGIN_KEY = 'user_logged_in';
const ADMIN_KEY = 'admin_logged_in';

const Navbar: React.FC = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userClassId, setUserClassId] = useState<string | null>(null);

  // 컴포넌트 마운트 시 로그인 상태 확인
  useEffect(() => {
    const userLoginStatus = localStorage.getItem(USER_LOGIN_KEY);
    const adminStatus = localStorage.getItem(ADMIN_KEY);

    if (userLoginStatus || adminStatus === 'true') {
      setIsLoggedIn(true);
      if (userLoginStatus) {
        setUserClassId(userLoginStatus);
      }
    }
  }, []);

  // 로그아웃 처리
  const handleLogout = () => {
    // 사용자 로그인 정보 제거
    localStorage.removeItem(USER_LOGIN_KEY);
    // 관리자 로그인 정보 제거
    localStorage.removeItem(ADMIN_KEY);

    // 메인 페이지로 이동
    navigate('/');
  };

  return (
    <AppBar
      position="static"
      elevation={0}
      sx={{
        background: 'transparent',
        backdropFilter: 'none',
        borderBottom: 'none',
        boxShadow: 'none',
      }}
    >
      <Toolbar sx={{ minHeight: '64px' }}>
        <Box
          component="img"
          src="/assets/비앤브이러닝_BL.png"
          alt="BNV Learning Logo"
          sx={{
            height: 28,
            marginRight: 2,
            filter: 'brightness(0) invert(1)',
          }}
        />
        <Typography
          variant="h6"
          component="div"
          sx={{
            flexGrow: 1,
            fontWeight: 700,
            color: 'white',
            textShadow: '0 2px 4px rgba(0, 0, 0, 0.3)',
          }}
        >
          BNV AI Tools
        </Typography>

        {isLoggedIn && (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            {userClassId && (
              <Typography
                variant="body2"
                sx={{
                  mr: 2,
                  color: 'rgba(255, 255, 255, 0.9)',
                  fontWeight: 500,
                  px: 2,
                  py: 0.5,
                  background: 'rgba(255, 255, 255, 0.1)',
                  backdropFilter: 'blur(10px)',
                  borderRadius: '12px',
                  border: '1px solid rgba(255, 255, 255, 0.2)',
                }}
              >
                {userClassId}
              </Typography>
            )}
            <Tooltip title="로그아웃" arrow>
              <IconButton
                onClick={handleLogout}
                sx={{
                  color: 'white',
                  background: 'rgba(255, 255, 255, 0.1)',
                  backdropFilter: 'blur(10px)',
                  border: '1px solid rgba(255, 255, 255, 0.2)',
                  borderRadius: '12px',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    background: 'rgba(255, 255, 255, 0.2)',
                    transform: 'translateY(-1px)',
                  },
                }}
              >
                <LogoutIcon />
              </IconButton>
            </Tooltip>
          </Box>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Navbar; 